import template from './relatedTask.html';

export default {
  template,
  bindings: {
    requirementsList: '<',
    onCompleteRequirement: '&',
    onAddRequirementModal: '&',
  },
};
